import { render, staticRenderFns } from "./PermissionsInfoModelsView.vue?vue&type=template&id=5f879b58&"
import script from "./PermissionsInfoModelsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsInfoModelsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports